
import React from "react";
import { useTranslation } from "react-i18next";

interface DashboardHeaderProps {
  username: string | null;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ username }) => {
  const { t } = useTranslation('dashboard');
  
  return (
    <div className="mb-6 md:mb-10">
      <h1 className="text-2xl md:text-3xl font-bold text-golf-800 mb-2">
        {username ? t('header.welcome', { username }) : t('header.defaultTitle')}
      </h1>
      <p className="text-muted-foreground">
        {t('header.subtitle')}
      </p>
    </div>
  );
};

export default DashboardHeader;
